import { render } from "./bodegas_usuarios.vue?vue&type=template&id=2c3b1f9f"
import script from "./bodegas_usuarios.vue?vue&type=script&lang=js"
export * from "./bodegas_usuarios.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__